import React, { useEffect, useState } from "react";
import Popup from "../../../../../../components/Popup";
import SelectGroup from "../../../../../../components/SelectGroup";

import "./styles.css"

export default function SelectCompaniesPopUp(props) {
    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        setCompanies(props.markedCompanies);
    }, [props.companies]);

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            tittle="Empresas"
        >
            <SelectGroup
                single={false}
                hides={[]}
                markeds={companies}
                setMarkeds={setCompanies}
            >
                {
                    props.companies.map(company => {
                        return (
                            <div key={company.id} className="companies-popup-container">
                                <p>{company.nome}</p>
                            </div>
                        )
                    })
                }
            </SelectGroup>
            <button onClick={() => {
                props.setCompanies(companies);
                props.setVisibility(false);
            }}>Selecionar</button>
        </Popup>
    );
}